import React, { useRef } from 'react';
import style from './Video.module.css';
import parse from 'html-react-parser';
import { useSelector } from 'react-redux';

function Video({ src, type, message }) {
  const { isChatFullScreen } = useSelector((state) => ({
    isChatFullScreen: state.messages.isChatFullScreen,
  }));
  const videoRef = useRef(null);
  const iframeRef = useRef(null);

  const sendMessageToParent = (message) => {
    window.parent.postMessage(message, '*');
  };

  const handleImage = (src, msg, fileType) => {
    sendMessageToParent({
      type: 'IMAGE_SCREEN',
      url: src,
      caption: msg || '',
      fileType: fileType,
    });
  };

  // Function to check if it's a YouTube link and extract video ID
  const getYouTubeEmbedUrl = (url) => {
    const regex = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=))([^?&]+)/;
    const match = url.match(regex);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  };

  const handlePlay = () => {
    // Pause all <video> elements
    document.querySelectorAll("video").forEach((vid) => {
      if (vid !== videoRef.current) {
        vid.pause();
      }
    });

    // Stop all YouTube iframes
    document.querySelectorAll("iframe").forEach((iframe) => {
      if (iframe !== iframeRef.current) {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }
    });
  };

  const youTubeEmbedUrl = getYouTubeEmbedUrl(src);

  return (
    <div
      className={`rcw-message-content ${!isChatFullScreen ? style.videocontainer : ''}`}
      onClick={() => handleImage(src, message, type)}
    >
      {youTubeEmbedUrl ? (
        // ✅ YouTube Video Embed
        <iframe
          className={style.video}
          src={youTubeEmbedUrl}
          title="YouTube video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
          sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
          allowFullScreen
          ref={iframeRef}
          onLoad={handlePlay}
        />
      ) : (
        // ✅ Regular Video File
        <video className={style.video} controls ref={videoRef} onPlay={handlePlay}>
          <source src={src} type={type} />
          Your browser does not support the video tag.
        </video>
      )}
      {message && <p className={style.caption}>{parse(message)}</p>}
    </div>
  );
}

export default Video;
